// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/workspace/app/(auth)/_layout.tsx"); } },
  "./(auth)/login.tsx": { enumerable: true, get() { return require("/workspace/app/(auth)/login.tsx"); } },
  "./(auth)/scanner.tsx": { enumerable: true, get() { return require("/workspace/app/(auth)/scanner.tsx"); } },
  "./(auth)/token-login.tsx": { enumerable: true, get() { return require("/workspace/app/(auth)/token-login.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/workspace/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/workspace/app/(tabs)/index.tsx"); } },
  "./(tabs)/index.web.tsx": { enumerable: true, get() { return require("/workspace/app/(tabs)/index.web.tsx"); } },
  "./(tabs)/notifications.tsx": { enumerable: true, get() { return require("/workspace/app/(tabs)/notifications.tsx"); } },
  "./(tabs)/settings.tsx": { enumerable: true, get() { return require("/workspace/app/(tabs)/settings.tsx"); } },
  "./_layout.native.tsx": { enumerable: true, get() { return require("/workspace/app/_layout.native.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/workspace/app/_layout.tsx"); } },
  "./_layout.web.tsx": { enumerable: true, get() { return require("/workspace/app/_layout.web.tsx"); } },
  "./call.tsx": { enumerable: true, get() { return require("/workspace/app/call.tsx"); } },
  "./call.web.tsx": { enumerable: true, get() { return require("/workspace/app/call.web.tsx"); } },
  "./chat/[channelId].tsx": { enumerable: true, get() { return require("/workspace/app/chat/[channelId].tsx"); } },
  "./modal.tsx": { enumerable: true, get() { return require("/workspace/app/modal.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;